// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__nLB9y","additionalInfo":"AgreementModal_additionalInfo__1tHQo"};